const baseURL5 = "https://friendsgoldsmith.newfriendsjewellers.com:9096";


// const baseURL5 ="https://friendserp2.newfriendsjewellers.com:9095";


export default baseURL5;